import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Text } from 'roo-ui/components';
import Currency from 'components/Currency';

const PriceBeforeDiscount = ({ total, hideCurrency, roundToCeiling, lineHeight, ...rest }) => {
  const { amount } = total;
  if (!amount) {
    return null;
  }
  return (
    <Flex mb="1px">
      <Currency
        amount={total.amount}
        currency={total.currency}
        roundToCeiling={roundToCeiling}
        hideCurrency={hideCurrency}
        textDecoration="line-through"
        color="greys.dusty"
        {...rest}
        data-testid="currency-before-discount"
      />
      <Text color="greys.dusty" lineHeight={lineHeight} fontSize="base">
        ~
      </Text>
    </Flex>
  );
};

PriceBeforeDiscount.propTypes = {
  total: PropTypes.object.isRequired,
  hideCurrency: PropTypes.bool,
  roundToCeiling: PropTypes.bool.isRequired,
  lineHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

PriceBeforeDiscount.defaultProps = {
  hideCurrency: false,
  lineHeight: 1,
};

export default PriceBeforeDiscount;
